export class NotSupportedError extends Error {
    constructor(version, maxVersion) {
        super('Not supported version: version=' + version + ', maxVersion=' + maxVersion);
    }
}
export class WebRTCBase {
    static millisToMicros(millis) {
        return (millis - WebRTCBase.TIMESTAMP_OFFSET) * 1000;
    }
    static millisToSeconds(millis) {
        return (millis - WebRTCBase.TIMESTAMP_OFFSET) / 1000;
    }
}
// actions
WebRTCBase.ACTION_INIT_CODEC = 'init_codec';
WebRTCBase.ACTION_DECODE_VIDEO = 'decode_video';
WebRTCBase.ACTION_DECODE_IMAGE = 'decode_image';
WebRTCBase.ACTION_DECODE_IMAGE_REPLY = 'decode_image.reply';
//
WebRTCBase.ACTION_CHANNEL = 'channel';
WebRTCBase.ACTION_ERROR = 'error';
WebRTCBase.ACTION_FIRST_FRAME = 'first_frame';
WebRTCBase.ACTION_RESET_FIRST_FRAME = 'reset_first_frame';
WebRTCBase.ACTION_GET_TIME = 'get_time';
WebRTCBase.ACTION_GET_TIME_REPLY = 'get_time.reply';
WebRTCBase.ACTION_CHANNEL_OBJECT = 'channel_object';
WebRTCBase.ACTION_CHANNEL_CLOSE = 'channel_close';
// one week (in milliseconds)
WebRTCBase.TIMESTAMP_OFFSET = 604800000;
export function base64ToBytes(base64) {
    const binString = atob(base64);
    return Uint8Array.from(binString, (m) => m.codePointAt(0));
}
export function bytesToBase64(bytes) {
    const binString = String.fromCodePoint(...bytes);
    return btoa(binString);
}
export function toBigEndian4(number) {
    let buffer = new ArrayBuffer(4);
    let view = new DataView(buffer);
    view.setInt32(0, number, false);
    let byteArray = new Uint8Array(buffer);
    return Array.from(byteArray);
}
export function toBigEndian2(number) {
    let buffer = new ArrayBuffer(2);
    let view = new DataView(buffer);
    view.setInt16(0, number, false);
    let byteArray = new Uint8Array(buffer);
    return Array.from(byteArray);
}
export function getByteBits(byte) {
    let ret = new Array(8);
    for (let i = 7, j = 0; i > -1; --i, ++j) {
        ret[j] = (byte >> i) & 1;
    }
    return ret;
}
export function compareUint8Array(uint8Array1, uint8Array2) {
    if ((uint8Array1 === null || uint8Array1 === undefined) && (uint8Array2 === null || uint8Array2 === undefined))
        return true;
    if (!(uint8Array1 instanceof Uint8Array && uint8Array2 instanceof Uint8Array) ||
        uint8Array1.byteLength !== uint8Array2.byteLength)
        return false;
    // iterate
    for (let i = 0; i < uint8Array1.byteLength; i++) {
        if (uint8Array1[i] !== uint8Array2[i]) {
            return false;
        }
    }
    return true;
}
